var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaveFigureMobile = function SvgWaveFigureMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 1 390 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.297 56.1535C123 97.0559 42.5209 62.3243 1 37.1534V1H235.297H391V47.7759C375.677 42.0922 328.204 22.3133 235.297 56.1535Z",
    fill: "#186346",
    stroke: "#186346"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaveFigureMobile);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIxIDEgMzkwIDc2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjM1LjI5NyA1Ni4xNTM1QzEyMyA5Ny4wNTU5IDQyLjUyMDkgNjIuMzI0MyAxIDM3LjE1MzRWMUgyMzUuMjk3SDM5MVY0Ny43NzU5QzM3NS42NzcgNDIuMDkyMiAzMjguMjA0IDIyLjMxMzMgMjM1LjI5NyA1Ni4xNTM1WiIgZmlsbD0iIzE4NjM0NiIgc3Ryb2tlPSIjMTg2MzQ2Ii8+Cjwvc3ZnPgo=";